module.exports = __webpack_public_path__ + "media/soundtrack.92fef59d.mp3";